import styled, { css } from 'styled-components'
import Box from 'components/Box'

export const dropdownDividerStyles = css(
  ({ theme }) => css`
    display: block;
    margin: 8px 0;
    height: 1px;
    background: ${theme.colors.border[2]};
  `
)

const DropdownDivider = styled(Box)`
  ${dropdownDividerStyles};
`

export default DropdownDivider
